import z from 'zod';
import { disclaimerErrorMap } from '../../validation';
import { Draft } from '../../common';
import { IFieldErrors, ValidationError, EmailSchema } from '../../validation';

export interface IRequestMeta {
  creator: string;
  creatorEmail: string;
  disclaimer: boolean;
  submitter: string;
}

export const MetaSchema = z.object({
  creator: z.string().min(1),
  creatorEmail: EmailSchema,
  disclaimer: z.literal(true, {
    errorMap: disclaimerErrorMap
  }),
  submitter: z.string().min(1)
});

/**
 * Execution of Validation Rules
 * 
 * The major expectation from the schema file.  This is the true public export
 * which will commonize the input and output into an application driven abstraction.
 * If this is the only function to reach the service layer, replacing the library will
 * be far more approachable as any logic leaning on this will not have proprietary output
 * in either return type or exception
 */
export const validate = (update: Draft<IRequestMeta>) => {
  try {
    // Ensure there are changes from the original record
    const validated = MetaSchema.parse(update);
    return {
      ...validated
    };
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};